<template>
  <div>
    <div v-if="iscn" class="footer">
      <div class="text">和转转一起拯救世界，让世界因流转更可持续！</div>
    </div>
    <div v-if="!iscn" class="footer">
      <div class="text text-en">Assemble，strive for a more sustainable world！</div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'footer-area',
  computed: {
    iscn: function() {
      return this.$store.state.lang === 'zh-cn'
    }
  },
  mounted() {
  }
})
</script>

<style scoped lang="scss">
.footer {
  position: relative;
  width: 100%;
  height: 360px;
  // margin-top: -100px;
  background: #111;
  min-width: 1280px;
}

.text {
  position: absolute;
  top: 146px;
  width: 100%;
  color: #fff;
  font-size: 56px;
  font-family: alibaba;
  line-height: 68px;
  text-align: center;
}
</style>
